import React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { useTranslation } from "react-i18next";

export interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  title?: string;
  children: React.ReactNode;
}

export const CollapseDetailItem: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { title, children, ...rest } = props;
  const { t } = useTranslation(["button"]);

  const [isCollapsed, setIsCollapsed] = React.useState(true);

  const onClick = () => {
    setIsCollapsed(!isCollapsed);
  };

  const innerCollapsedStyles = title
    ? innerCollapsedStyleWithTitle
    : innerCollapsedStyle;
  const innerStyles = isCollapsed ? innerCollapsedStyles : innerStyle;
  const buttonText = isCollapsed ? t("common.showAll") : t("common.showLess");

  return (
    <div css={blockStyle} {...rest}>
      <div css={innerStyles}>
        {title && <h3 css={titleStyle}>{title}</h3>}
        {children}
      </div>
      <div css={buttonBlockStyle}>
        <a css={buttonStyle} onClick={onClick}>
          {buttonText}
        </a>
      </div>
    </div>
  );
};

const blockStyle = css`
  padding: ${space.atom2x} 0;
  color: ${textColor.secondaryDarkColor};
`;
const titleStyle = css`
  font-size: ${fontSize.subHeading};
  line-height: ${lineHeight.subHeadline2};
  padding: ${space.atom};
`;
const innerStyle = css`
  height: auto;
`;
const innerCollapsedStyle = css`
  height: 3rem;
  position: relative;
  overflow: hidden;
  mask-image: linear-gradient(0deg, transparent, black 2rem);
`;
const innerCollapsedStyleWithTitle = css`
  ${innerCollapsedStyle};
  height: 5.5rem;
  mask-image: linear-gradient(0deg, transparent, black 2rem);
`;
const buttonBlockStyle = css`
  display: flex;
  justify-content: flex-start;
  padding: ${space.atom1_5x} ${space.atom} 0;
`;
const buttonStyle = css`
  color: ${accentColor.primaryColor};
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.5rem;
`;
